import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { isNullOrEmpty } from '@awp/core/utils';
import { ContentType } from '../models';
import { ContentPipe } from './content.pipe';
import { ContentProvider } from '../content.provider';
import { ContentParser } from '../content.parser';
var HtmlContentPipe = /** @class */ (function (_super) {
    tslib_1.__extends(HtmlContentPipe, _super);
    function HtmlContentPipe(contentProvider, contentParser, changeDetectorRef) {
        return _super.call(this, contentProvider, contentParser, changeDetectorRef) || this;
    }
    HtmlContentPipe.prototype.updateValue = function (key, interpolateParams) {
        var _this = this;
        // This subscription completes.
        this.contentProvider.get(key, interpolateParams)
            .pipe(switchMap(function (value) {
            if (value != null && value.type === ContentType.Html) {
                if (!isNullOrEmpty(value.content)) {
                    return of(_this.contentProvider.parserInterpolate(value.content, interpolateParams));
                }
                else if (!isNullOrEmpty(value.href)) {
                    return _this.contentProvider.fetchContent(value.href, 'html')
                        .pipe(map(function (response) {
                        return _this.contentProvider.parserInterpolate(response, interpolateParams);
                    }));
                }
                else {
                    return of(null);
                }
            }
            return of(value);
        }))
            .subscribe(function (value) {
            _this.value = value;
            _this.lastKey = key;
            _this.changeDetectorRef.markForCheck();
        });
    };
    return HtmlContentPipe;
}(ContentPipe));
export { HtmlContentPipe };
